module.exports = __webpack_public_path__ + "img/cc_no_bg.c3678893.png";